/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHolidays } from 'packages/blu-booking/src/data_fetching/Holidays/Holidays';
import { usePointOfSaleHoursCalendar } from 'packages/blu-booking/src/data_fetching/PointOfSaleHours/PointOfSaleHoursCalendar';
import { usePointOfSaleHoursShift } from 'packages/blu-booking/src/data_fetching/PointOfSaleHours/PointOfSaleHoursShift';
import { RootState } from 'packages/blu-booking/src/store';
import { useDeferredValue, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

interface UseSchedulerDataParams {
  selectedDate: Date;
  view: string;
  selectedPointOfSale: any;
  selectedUsers: any[];
}

/**
 * Gestisce il data fetching del calendario Default:
 * - Orari lavorativi del punto vendita (calendar)
 * - Turni del punto vendita (shift)
 * - Festività (holidays)
 * - Stato di loading aggregato
 *
 * Usa useDeferredValue per calendar e shift per evitare
 * che un cambio di dati blocchi il rendering del calendario.
 */
export function useSchedulerData() {
  const { appointments, loadingAppointments } = useSelector(
    (state: RootState) => state.bluBookingaAppointments
  );

  const { data: holidays, isLoading: isLoadingHolidays } = useHolidays();

  const isLoadingCalendarOrHolidays = useMemo(
    () => loadingAppointments || isLoadingHolidays,
    [loadingAppointments, isLoadingHolidays]
  );

  return {
    appointments,
    holidays,
    isLoadingCalendarOrHolidays,
  };
}
